import { Button, Modal, ModalButtonBar } from '@itwin/itwinui-react';
import * as React from 'react';
import * as ReactDom from 'react-dom';

export const openConfirmationDialog = async (
  title: string,
  message: string,
  primaryButtonText: string,
  secondaryButtonText: string
): Promise<boolean> => {
  let confirmationCallback: (value: boolean | PromiseLike<boolean>) => void;
  const promise = new Promise<boolean>(
    resolve => (confirmationCallback = resolve)
  );

  const dialogElement = createDialogElement();

  const onClick = val => {
    confirmationCallback(val);
    destroyDialogElement(dialogElement);
  };

  ReactDom.render(
    <Modal
      className='scs-confirmation-dialog'
      title={title}
      isOpen={true}
      onClose={() => destroyDialogElement(dialogElement)}
    >
      <div>{message}</div>
      <ModalButtonBar>
        <Button styleType='high-visibility' onClick={() => onClick(true)}>
          {primaryButtonText}
        </Button>
        <Button onClick={() => onClick(false)}>{secondaryButtonText}</Button>
      </ModalButtonBar>
    </Modal>,
    dialogElement
  );

  return promise;
};

const createDialogElement = (): HTMLDivElement => {
  const createdElement = document.createElement('div');
  createdElement.id = new Date().toISOString();
  document.body.appendChild(createdElement);
  return createdElement;
};

const destroyDialogElement = (element: HTMLDivElement): void => {
  document.body.removeChild(element);
};
